import { Directive } from '@angular/core';

@Directive({
	selector: 'a[target]',
	host: {
		'[attr.rel]': '"noopener noreferrer"',
	},
	standalone: false,
})
export class TargetBlankDirective {
}